/**
 * Shared sub-delegation UI types + display copy.
 *
 * Single source for the permission vocabulary used by BOTH the admin
 * portal (SubDelegatesModal) and the owner self-service management page —
 * features cannot import from each other, so this lives in `shared/`.
 */

export type DelegationPermission =
  | 'MESSAGING'
  | 'EMAIL_NOTIFICATIONS'
  | 'WORKSPACE_OPERATIONS'
  | 'PROFILE_MANAGEMENT';

export const DELEGATION_PERMISSIONS: readonly DelegationPermission[] = [
  'MESSAGING',
  'EMAIL_NOTIFICATIONS',
  'WORKSPACE_OPERATIONS',
  'PROFILE_MANAGEMENT',
] as const;

export const PERMISSION_LABELS: Record<DelegationPermission, string> = {
  MESSAGING: 'Messaging',
  EMAIL_NOTIFICATIONS: 'Email notifications',
  WORKSPACE_OPERATIONS: 'Workspace operations',
  PROFILE_MANAGEMENT: 'Profile management',
};

export const PERMISSION_DESCRIPTIONS: Record<DelegationPermission, string> = {
  MESSAGING: 'Read and send messages on behalf of the workspace owner',
  EMAIL_NOTIFICATIONS: 'Receive unread-message email notifications',
  WORKSPACE_OPERATIONS: 'Manage clients, network, referrals and resources',
  PROFILE_MANAGEMENT: "Edit the workspace owner's profile",
};

export type DelegateStatus = 'ACTIVE' | 'PENDING' | 'EXPIRED';
